/* Extracted from snippets/cart-products-custom.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

(function () {
    if (window.__cpCartInit) return;
    window.__cpCartInit = true;

    function reRenderCart() {
      var sectionEl = document.querySelector('cart-items-component');
      var sectionId = sectionEl && sectionEl.dataset.sectionId;
      if (!sectionId) { window.location.reload(); return Promise.resolve(); }
      return fetch('/?sections=' + encodeURIComponent(sectionId))
        .then(function (r) { return r.json(); })
        .then(function (sections) {
          var html = sections[sectionId];
          if (!html) { window.location.reload(); return; }
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('cart-items-component');
          if (fresh && sectionEl) { sectionEl.innerHTML = fresh.innerHTML; }
          /* Let re-render-safe widgets (e.g. cart delivery countdown) refresh */
          document.dispatchEvent(new CustomEvent('cart:rerendered'));
        });
    }

    function syncBubble(count) {
      document.querySelectorAll('.ch__cart-bubble').forEach(function (el) { el.textContent = count; });
    }

    /* Shared with the cart summary (discount / note) so there is one re-render path */
    window.scwReRenderCart = reRenderCart;
    window.scwSyncCartBubble = syncBubble;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-cp-change]');
      if (!btn) return;
      e.preventDefault();

      var key = btn.getAttribute('data-key');
      var qty = parseInt(btn.getAttribute('data-qty'), 10);
      if (isNaN(qty) || qty < 0) qty = 0;

      var row = btn.closest('.cp-item');
      if (row) row.classList.add('is-updating');

      /* GA4 remove_from_cart when removing */
      if (qty === 0 && row && window.dataLayer) {
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'remove_from_cart',
          ecommerce: {
            items: [{
              item_id: row.getAttribute('data-item-id'),
              item_name: row.getAttribute('data-item-name'),
              item_variant: row.getAttribute('data-item-variant'),
              price: parseFloat(row.getAttribute('data-item-price')) || 0,
              quantity: parseInt(row.getAttribute('data-item-quantity'), 10) || 1
            }]
          }
        });
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart && typeof cart.item_count !== 'undefined') syncBubble(cart.item_count);
          return reRenderCart();
        })
        .catch(function () {
          if (row) row.classList.remove('is-updating');
          window.location.reload();
        });
    });
  })();
